<app-menu class="over-three"></app-menu>
<app-side-left class="over-three"></app-side-left>

<!-- <div class="over-three right-buttom">
    <button mat-icon-button  (click)="openChat()" class="example-icon" aria-label="start chat">
        <mat-icon>chat_bubble</mat-icon>
    </button>
</div> -->
<app-three></app-three>
